/* eslint-disable no-return-assign */
import formatNumbersMiles from './formatNumbersMiles';

const totals = (array, type) => {
  const result = array?.reduce(
    (total, currentValue) => (total += parseInt(currentValue[type], 10) || 0),
    0,
  );
  return formatNumbersMiles(result);
};

let newArray = [];

const countZone = (array, filter, param) => {
  newArray = array;
  const result = array
    .filter(
      (feature) => feature.properties.zona == filter
        && feature.properties.zona !== undefined,
    )
    .reduce((t, acc) => t + acc?.properties[param] || 0, 0);
  return formatNumbersMiles(result) || 0;
};

const totalStores = (filter) => {
  const result = newArray.filter(
    (feature) => feature.properties.zona === filter
      && feature.properties.zona !== undefined,
  );

  return result.length - 1 || 0;
};

const onMouseResultsMap = { totals, countZone, totalStores };
export default onMouseResultsMap;
